import React from 'react';

import { formatAccountNumber } from '@eika-infrastruktur/format';

import { usePaymentAccountContext } from '../../../../../hooks/useAccountState';
import useTranslation from '../../../../../hooks/useTranslation';
import useFormContext from '../../form/useFormContext';

import './SummaryDescription.scss';

const FromAccountSummary: React.FC = () => {
    const translated = useTranslation();
    const { state } = useFormContext();
    const { targetFromAccount } = usePaymentAccountContext();
    return (
        <li key="fromAccountSummary" className="from-account__list-item">
            <h3 className="summary-description__title">{translated.transferFromAccount}</h3>
            <dd className="summary-description__spacing-to-title summary-description__no-margin">
                {targetFromAccount?.alias}
            </dd>
            <dd className="summary-description__info">{formatAccountNumber(state.fromAccount)}</dd>
        </li>
    );
};

export default FromAccountSummary;
